module.exports = __webpack_public_path__ + "img/tonglu.e2b9dae3.png";